module.exports = __webpack_public_path__ + "img/shop_C_2.8570d100.png";